import {
    ResponsiveDisplayType,
    ResponsiveHeightType,
    ResponsiveTextAlignType,
    ResponsiveWidthType,
} from '@fiverr-private/theme/src/components/Box/types';
import * as styles from './styles.ve.css';

export const sellers = {
    '1-col': [
        {
            name: 'Hidden 1',
            className: styles.sellersGalleryCol1Row1,
            width: '100%' as ResponsiveWidthType,
        },
        {
            name: 'Miles',
            domain: 'Resume Writer',
            className: styles.sellersGalleryCol1Row2,
            width: '100%' as ResponsiveWidthType,
            textAlign: 'end' as ResponsiveTextAlignType,
            'data-speed': '1.5',
            alt: 'Seller 1',
            src: 'a9e2c1e639b73889cc6099569e512feb-1751456704344/seller-1-v2560-cropped-2x.jpg',
            imgWidth: {
                default: 212,
                sm: 232,
                md: 252,
                lg: 312,
                xl: 436,
                xxl: 562,
                xxxl: 664,
            },
        },
        {
            name: 'Seller 2',
            className: styles.sellersGalleryCol1Row3,
            width: '100%' as ResponsiveWidthType,
            textAlign: 'end' as ResponsiveTextAlignType,
            'data-speed': '1.25',
            alt: 'Seller 2',
            src: 'b72f820ad48aea3fe4b668c442d1d2eb-1751867254512/seller-2-v2560-cropped-2x.jpg',
            imgWidth: {
                default: 212,
                sm: 232,
                md: 252,
                lg: 312,
                xl: 436,
                xxl: 562,
                xxxl: 664,
            },
        },
        {
            name: 'Seller 3',
            className: styles.sellersGalleryCol1Row4,
            width: '100%' as ResponsiveWidthType,
            textAlign: 'end' as ResponsiveTextAlignType,
            display: {
                default: 'none',
                lg: 'block',
            } as ResponsiveDisplayType,
            alt: 'Seller 3',
            src: 'b72f820ad48aea3fe4b668c442d1d2eb-1751867254510/seller-3-v2560-cropped-2x.jpg',
            imgWidth: {
                default: 312,
                xl: 436,
                xxl: 562,
                xxxl: 664,
            },
        },
    ],
    '2-col': {
        '1-row': {
            '1-col': [
                {
                    name: 'Seller 4',
                    className: styles.sellersGalleryCol2Row1Col1,
                    height: '100%' as ResponsiveHeightType,
                    minWidth: {
                        lg: '196px',
                        xl: '244px',
                    } as ResponsiveWidthType,
                    width: {
                        default: '100%',
                        lg: '38%',
                        xl: '38%',
                    } as ResponsiveWidthType,
                    maxWidth: {
                        lg: '244px',
                        xl: '342px',
                    } as ResponsiveWidthType,
                    'data-speed': '1.5',
                    alt: 'Seller 4',
                    src: 'b72f820ad48aea3fe4b668c442d1d2eb-1751867254501/seller-4-v2560-cropped-2x.jpg',
                    imgWidth: {
                        default: 212,
                        sm: 232,
                        md: 252,
                        lg: 244,
                        xl: 342,
                        xxl: 440,
                        xxxl: 568,
                    },
                },
            ],
            '2-col': [
                {
                    name: 'Hidden 2',
                    className: styles.sellersGalleryCol2Row1Col2Row1,
                    width: '100%' as ResponsiveWidthType,
                    display: {
                        default: 'none',
                        lg: 'block',
                    } as ResponsiveDisplayType,
                },
                {
                    name: 'Seller 5',
                    className: styles.sellersGalleryCol2Row1Col2Row2,
                    width: '100%' as ResponsiveWidthType,
                    'data-speed': '2',
                    display: {
                        default: 'none',
                        lg: 'block',
                    } as ResponsiveDisplayType,
                    alt: 'Seller 5',
                    src: 'b72f820ad48aea3fe4b668c442d1d2eb-1751867254521/seller-5-v2560-cropped-2x.jpg',
                    imgWidth: {
                        lg: 380,
                        xl: 532,
                        xxl: 682,
                        xxxl: 800,
                    },
                },
            ],
        },
        '2-row': {
            '1-col': [
                {
                    name: 'Seller 6',
                    'data-speed': '2',
                    display: {
                        default: 'none',
                        lg: 'block',
                    } as ResponsiveDisplayType,
                    style: {
                        aspectRatio: '0.89',
                    },
                    alt: 'Seller 6',
                    src: 'b72f820ad48aea3fe4b668c442d1d2eb-1751867254504/seller-6-v2560-cropped-2x.jpg',
                    imgWidth: {
                        default: 212,
                        sm: 232,
                        md: 252,
                        lg: 314,
                        xl: 440,
                        xxl: 569,
                        xxxl: 664,
                    },
                },
                {
                    name: 'Jonah',
                    domain: 'Software Engineer',
                    className: `${styles.sellersGalleryCol2Row2Col1Row2} carousel-seller`,
                    alt: 'Seller 7',
                    src: 'b72f820ad48aea3fe4b668c442d1d2eb-1751867254519/seller-7-v2560-cropped-2x.jpg',
                    'data-transfer-to-carousel-item': true,
                    isFade: false,
                    imgWidth: {
                        default: 212,
                        sm: 232,
                        md: 252,
                        lg: 314,
                        xl: 440,
                        xxl: 569,
                        xxxl: 664,
                    },
                },
            ],
            '2-col': [
                {
                    name: 'Lora',
                    domain: 'SEO Specialist',
                    className: 'carousel-seller',
                    style: {
                        aspectRatio: '0.8',
                    },
                    alt: 'Seller 8',
                    src: 'b72f820ad48aea3fe4b668c442d1d2eb-1751867254520/seller-8-v2560-cropped-2x.jpg',
                    'data-transfer-to-carousel-item': true,
                    isFade: false,
                    imgWidth: {
                        lg: 310,
                        xl: 432,
                        xxl: 558,
                        xxxl: 664,
                    },
                },
                {
                    name: 'Seller 9',
                    style: {
                        aspectRatio: '0.98',
                    },
                    'data-speed': '0.25',
                    alt: 'Seller 9',
                    src: 'b72f820ad48aea3fe4b668c442d1d2eb-1751867254503/seller-9-v2560-cropped-2x.jpg',
                    imgWidth: {
                        lg: 310,
                        xl: 432,
                        xxl: 558,
                        xxxl: 664,
                    },
                },
            ],
        },
    },
    '3-col': {
        '1-row': {
            '1-col': [
                {
                    name: 'Hidden 3',
                    className: styles.sellersGalleryCol3Row1Col1Row1,
                    width: '100%' as ResponsiveWidthType,
                    display: {
                        default: 'none',
                        lg: 'block',
                    } as ResponsiveDisplayType,
                    flexGrow: 1,
                },
                {
                    name: 'Seller 10',
                    className: styles.sellersGalleryCol3Row1Col1Row2,
                    'data-speed': '1.5',
                    alt: 'Seller 10',
                    src: 'b72f820ad48aea3fe4b668c442d1d2eb-1751867254515/seller-10-v2560-cropped-2x.jpg',
                    imgWidth: {
                        default: 212,
                        sm: 232,
                        md: 252,
                        lg: 249,
                        xl: 348,
                        xxl: 448,
                        xxxl: 568,
                    },
                },
            ],
            '2-col': [
                {
                    name: 'Hidden 4',
                    className: styles.sellersGalleryCol3Row1Col2Row1,
                    width: '100%' as ResponsiveWidthType,
                    display: {
                        default: 'block',
                        lg: 'none',
                    } as ResponsiveDisplayType,
                },
                {
                    name: 'Camille',
                    domain: 'Marketing Advisor',
                    className: styles.sellersGalleryCol3Row1Col2Row2,
                    width: '100%' as ResponsiveWidthType,
                    height: {
                        lg: '100%',
                    } as ResponsiveHeightType,
                    alt: 'Seller 11',
                    src: 'b72f820ad48aea3fe4b668c442d1d2eb-1751867254517/seller-11-v2560-cropped-2x.jpg',
                    'data-speed': '1.65',
                    imgWidth: {
                        default: 212,
                        sm: 232,
                        md: 252,
                        lg: 310,
                        xl: 432,
                        xxl: 558,
                        xxxl: 664,
                    },
                },
                {
                    name: 'Seller 17',
                    width: '100%' as ResponsiveWidthType,
                    style: {
                        aspectRatio: '0.75',
                    },
                    display: {
                        default: 'block',
                        lg: 'none',
                    } as ResponsiveDisplayType,
                    alt: 'Seller 17',
                    src: 'b72f820ad48aea3fe4b668c442d1d2eb-1751867254503/seller-9-v2560-cropped-2x.jpg',
                    imgWidth: {
                        default: 212,
                        sm: 232,
                        md: 252,
                    },
                },
            ],
            '3-col': [
                {
                    name: 'Hidden 5',
                    height: {
                        sm: '25px',
                        md: '28px',
                        lg: '100%',
                    } as ResponsiveHeightType,
                },
                {
                    name: 'Seller 18',
                    display: {
                        default: 'none',
                        sm: 'block',
                        md: 'block',
                        lg: 'none',
                    } as ResponsiveDisplayType,
                    style: {
                        aspectRatio: '0.75',
                        maxHeight: '100%',
                    },
                    alt: 'Seller 18',
                    src: 'b72f820ad48aea3fe4b668c442d1d2eb-1751867254517/seller-15-v2560-cropped-2x.jpg',
                    imgWidth: {
                        sm: 232,
                        md: 252,
                    },
                },
                {
                    name: 'Seller 19',
                    display: {
                        default: 'none',
                        sm: 'block',
                        md: 'block',
                        lg: 'none',
                    } as ResponsiveDisplayType,
                    style: { aspectRatio: '0.75', maxHeight: '100%' },
                    alt: 'Seller 19',
                    src: 'b72f820ad48aea3fe4b668c442d1d2eb-1751867254520/seller-8-v2560-cropped-2x.jpg',
                    imgWidth: {
                        sm: 232,
                        md: 252,
                    },
                },
            ],
        },
        '2-row': {
            '1-col': [
                {
                    name: 'Seller 12',
                    isFade: false,
                    className: 'carousel-seller',
                    'data-transfer-to-carousel-item': true,
                    style: {
                        aspectRatio: '0.76',
                    },
                    alt: 'Seller 12',
                    src: 'b5101d497d622d421154e932ceaa7927-1751867297260/ProSeller-1-v2560-cropped-2x.jpg',
                    imgWidth: {
                        lg: 344,
                        xl: 440,
                        xxl: 620,
                        xxxl: 720,
                    },
                },
                {
                    name: 'Seller 13',
                    style: {
                        aspectRatio: '1.17',
                    },
                    'data-speed': '0.5',
                    alt: 'Seller 13',
                    src: 'b72f820ad48aea3fe4b668c442d1d2eb-1751867254505/seller-13-v2560-cropped-2x.jpg',
                    imgWidth: {
                        lg: 344,
                        xl: 440,
                        xxl: 620,
                        xxxl: 720,
                    },
                },
            ],
            '2-col': [
                {
                    name: 'Seller 14',
                    style: {
                        aspectRatio: '1.47',
                    },
                    'data-speed': '1.25',
                    alt: 'Seller 14',
                    src: 'b72f820ad48aea3fe4b668c442d1d2eb-1751867254518/seller-14-v2560-cropped-2x.jpg',
                    imgWidth: {
                        lg: 314,
                        xl: 438,
                        xxl: 564,
                        xxxl: 664,
                    },
                },
                {
                    name: 'Seller 15',
                    style: {
                        aspectRatio: '0.99',
                    },
                    alt: 'Seller 15',
                    src: 'b72f820ad48aea3fe4b668c442d1d2eb-1751867254517/seller-15-v2560-cropped-2x.jpg',
                    imgWidth: {
                        lg: 314,
                        xl: 438,
                        xxl: 564,
                        xxxl: 664,
                    },
                },
                {
                    name: 'Seller 16',
                    style: {
                        aspectRatio: '0.84',
                    },
                    alt: 'Seller 16',
                    src: 'b72f820ad48aea3fe4b668c442d1d2eb-1751867254500/seller-16-v2560-cropped-2x.jpg',
                    imgWidth: {
                        lg: 314,
                        xl: 438,
                        xxl: 564,
                        xxxl: 664,
                    },
                },
            ],
        },
    },
};
